import { AddAlert } from '../../../../component';
import { loading, loaded } from '../../../../layout/redux/layoutActions';
import { generateMoreFilters } from '../../moreFilters/redux/moreFiltersActions';
import {
  modalOpen,
  setMarketType,
  setIsLoadingMap,
  setDisplayCharts,
} from '../../redux/dashboardActions';
import { setBigNumbers } from '../../bigNumbers/redux/bigNumbersActions';
import {
  setRealtyType,
  setMinUsefulArea,
  setMaxUsefulArea,
  setMinDate,
  setMaxDate,
} from '../../charts/redux/charts.actions';
import {
  setLaunchingYearsSecondary,
  updateInputIntervalsSecondary,
  updateRequestStatusSecondary,
  updatePayloadRequest,
  closeInfowindowsSecondary,
  setInfowindowsSecondary,
  updateBuildingData,
  updateChartsDataSecondary,
} from './offersSecondary.actions';
import {
  getSecondaryList,
  getPinsOffersSecondary,
  getBigNumbersOffersSecondary,
  getRealtiesByPeriodOffersSecondary,
  getAveragePricePerSquareMeterOffersSecondary,
  getAdsPerExistingRealtiesOffersSecondary,
  getInfoWindowData,
  getModalInfoOffersSecondary,
} from './offersSecondary.infra';
import { generateMarkersOnMap } from './offersSecondary.map';
import { buildCoordinates } from '../../../../shared/utils/map';
import infoWindowOffersSecundary from '../components/singleOfferInfowindow';
import { getHeatmapDataFromBigNumber } from '../../heatmap/controllers/heatmap.controller';
import Map from 'eemovel-map-library/src/data/google-maps/map';
import multipleOffersInfowindow from '../components/multipleOffersInfowindow';

export const generateSecondaryList = () => {
  return (dispatch) => {
    let newLaunchingYears = '';
    dispatch(loading());
    Promise.resolve(getSecondaryList())
      .then((res) => {
        newLaunchingYears = res.data.launching_years;
      })
      .catch((err) => {
        console.error(err);
        newLaunchingYears = [2019, 2020, 2021, 2022];
      })
      .finally((_) => {
        dispatch(setLaunchingYearsSecondary(newLaunchingYears));
        dispatch(loaded());
      });
  };
};

export const payloadBuilder = (data, moreFilters, type) => {
  const location = buildCoordinates();
  let inputIntervals = {};
  Object.keys(data.inputIntervals).forEach((el) => {
    const val = data.inputIntervals[el];
    if (val.min !== '' && val.max !== '') {
      const validateValue = {
        min: val.min.toString(),
        max: val.max.toString(),
      };
      if (validateValue.min.includes(','))
        validateValue.min = validateValue.min.replace(',', '.');
      if (validateValue.max.includes(','))
        validateValue.max = validateValue.max.replace(',', '.');
      if (validateValue.min.includes('R$')) {
        validateValue.min = validateValue.min
          .split('R$')[1]
          .replaceAll('.', '');
      }
      if (validateValue.max.includes('R$')) {
        validateValue.max = validateValue.max
          .split('R$')[1]
          .replaceAll('.', '');
      }
      const valor =
        el === 'timeframe'
          ? { min: val.min, max: val.max }
          : { min: Number(validateValue.min), max: Number(validateValue.max) };
      inputIntervals = { ...inputIntervals, [el]: valor };
    }
  });
  const newData = {
    ...data,
    inputIntervals,
  };
  if (!location) {
    return (dispatch) => {
      dispatch(AddAlert('warning', 'Selecione uma área no mapa'));
    };
  } else {
    const bedrooms = newData.bedrooms
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const suites = newData.suites
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const garages = newData.garages
      .filter((el) => el.selected === true)
      .map((elem) => (isNaN(elem.name) ? 4 : Number(elem.name)));
    const payload = moreFilters
      ? {
          location,
          ...newData,
          bedrooms,
          suites,
          garages,
          moreFilters,
        }
      : {
          location,
          ...newData,
          bedrooms,
          suites,
          garages,
        };
    return (dispatch) => {
      dispatch(searchRealtyOffersSecondary(payload, type));
      dispatch(updatePayloadRequest(payload));
    };
  }
};

const generateBigNumbers = (dispatch, res, payload) => {
  const bigNumbers = res[0]?.data?.data;
  const { pins, max_square_mt_price } = res[1]?.data;

  if (max_square_mt_price) {
    bigNumbers.max_square_mt_price = max_square_mt_price;
  }

  getHeatmapDataFromBigNumber(pins, bigNumbers, 'secondaryMarket');
  dispatch([
    generateMarkersOnMap(pins, 'secondary', payload),
    setBigNumbers(bigNumbers),
    loaded(),
    setDisplayCharts('secondaryMarket'),
  ]);
};

export const searchRealtyOffersSecondary = (payload, type) => {
  return (dispatch) => {
    dispatch(loading());
    Promise.all([
      getBigNumbersOffersSecondary(payload),
      getPinsOffersSecondary(payload),
    ])
      .then((response) => {
        if (response[0]) {
          generateBigNumbers(dispatch, response, payload);
        } else {
          dispatch(
            AddAlert(
              'warning',
              'Sem Resultados. Tente aumentar a área ou alterar os filtros usados nessa pesquisa.'
            )
          );
        }
      })
      .catch((e) => {
        console.error(e);

        dispatch(setDisplayCharts(null));
      })
      .finally(() => dispatch(loaded()));
  };
};

const updatingRequestsStatus = (dispatch, status) => {
  dispatch([
    updateRequestStatusSecondary({
      name: 'realtyAnnouncedByPeriod',
      value: status,
    }),
    updateRequestStatusSecondary({
      name: 'adsPerExistingRealties',
      value: status,
    }),
    updateRequestStatusSecondary({
      name: 'averagePricePerSqMt',
      value: status,
    }),
  ]);
};

const updatingChartsDataOffersSecundary = (dispatch, res) => {
  dispatch([
    updateChartsDataSecondary({
      name: 'realty_announced_by_period',
      value: res[0]?.data?.data?.graph,
    }),
    updateChartsDataSecondary({
      name: 'realty_announced_by_period_mean',
      value: res[0]?.data?.data?.mean,
    }),
    updateChartsDataSecondary({
      name: 'average_realty_announced_by_period',
      value: res[1]?.data?.data?.mean,
    }),
    updateChartsDataSecondary({
      name: 'price_variation_by_period',
      value: res[1]?.data?.data?.graph,
    }),
    updateChartsDataSecondary({
      name: 'ads_per_existing_realties',
      value: res[2]?.data?.data?.graph,
    }),
    updateChartsDataSecondary({
      name: 'ads_per_existing_realties_mean',
      value: res[2]?.data?.data?.mean,
    }),
    updateChartsDataSecondary({
      name: 'average_realties_announced_over_existing_realties',
      value: res[2]?.data?.data?.mean,
    }),
  ]);
};

export const generateChartsOffersSecondary = (payload) => {
  return (dispatch) => {
    dispatch(loading());
    updatingRequestsStatus(dispatch, 'LOADING');
    Promise.all([
      getRealtiesByPeriodOffersSecondary(payload),
      getAveragePricePerSquareMeterOffersSecondary(payload),
      getAdsPerExistingRealtiesOffersSecondary(payload),
    ])
      .then((res) => {
        updatingChartsDataOffersSecundary(dispatch, res);
        updatingRequestsStatus(dispatch, 'LOADED');
        dispatch(setDisplayCharts('secondaryMarket'));
      })
      .catch(() => {
        dispatch(
          AddAlert('error', 'Algo deu errado. Tente novamente mais tarde!')
        );
        updatingRequestsStatus(dispatch, 'FAILED');
      })
      .finally(() => {
        dispatch(loaded());
      });
  };
};

export const renderResponse = (payload, res, type) => {
  return (dispatch) => {
    dispatch([
      setMarketType(type),
      setChartsData(res?.data),
      generateMarkersOnMap(res?.data?.realties, type),
      setBigNumbers(res?.data?.big_numbers),
    ]);
    updatingRequestsStatus(dispatch, 'LOADED');
    setRealtyType(payload?.realtyType.name);
    if (payload?.inputIntervals.timeframe) {
      dispatch([
        generateMoreFilters(payload?.inputIntervals?.timeframe),
        setMinDate(payload?.inputIntervals?.timeframe?.min),
        setMaxDate(payload?.inputIntervals?.timeframe?.max),
      ]);
    }
    if (payload?.inputIntervals?.privateAreaInterval) {
      dispatch([
        setMinUsefulArea(payload?.inputIntervals?.privateAreaInterval?.min),
        setMaxUsefulArea(payload?.inputIntervals?.privateAreaInterval?.max),
      ]);
    }
    dispatch(setDisplayCharts(null));
  };
};

export const handlePriceInputs = (e, v, tuple, type) => {
  let name;
  let maskedValue = '';
  const replaceDots = e.value.replaceAll('.', '').split('R$');
  const valueAsFloat =
    replaceDots.length === 2
      ? parseInt(replaceDots[1])
      : parseInt(replaceDots[0]);
  if (!Number.isNaN(valueAsFloat)) {
    maskedValue = valueAsFloat.toLocaleString('pt-br', {
      style: 'currency',
      currency: 'BRL',
      maximumFractionDigits: 0,
    });
  }
  if (e.name.includes('min')) {
    tuple.min = maskedValue;
    name = e.name.split('min')[0];
  } else {
    tuple.max = maskedValue;
    name = e.name.split('max')[0];
  }
  const payload = {
    name,
    value: tuple,
  };
  return (dispatch) => {
    dispatch(updateInputIntervalsSecondary(payload));
  };
};

export const handleInputsIntervals = (e, v, tuple, type, typeNumber) => {
  return (dispatch) => {
    let name;
    if (!Number.isNaN(parseInt(e.value)) && parseInt(e.value) < 0) return;
    if (!e.value.match(/^(0|[1-9]\d*)+(,)?(\d{0,3})?$/) && e.value.length > 0)
      return;
    if (e.name.includes('min')) {
      tuple.min = e.value.toString();

      name = e.name.split('min')[0];
    } else {
      name = e.name.split('max')[0];
      tuple.max = e.value.toString();
    }
    const payload = {
      name,
      value: tuple,
    };
    dispatch(updateInputIntervalsSecondary(payload));
  };
};

const fieldsDictionary = {
  timeframemin: 'Período Inicial',
  timeframemax: 'Período Final',
  privateAreaIntervalmin: 'Área Privativa Inicial',
  privateAreaIntervalmax: 'Área Privativa Final',
  unitPricemin: 'Faixa de preço da Unidade Inicial',
  unitPricemax: 'Faixa de preço da Unidade Final',
  pricePerSquareMtmin: 'Faixa de preço/m² Inicial',
  pricePerSquareMtmax: 'Faixa de preço/m² Final',
  realtyAgemin: 'Idade do Imóvel Inicial',
  realtyAgemax: 'Idade do Imóvel Final',
};

export const validateForm = (formData, validation, type, moreFilters) => {
  let flag = false;
  return (dispatch) => {
    if (!formData.realtyType.id) {
      dispatch(AddAlert('warning', 'Tipo de imóvel é um campo obrigatório'));
      flag = true;
    }
    if (!Object.values(validation)?.every((el) => el === false)) {
      const removedFalses = Object.entries(validation).filter(
        (el) => el[1] !== false
      );
      const errors = removedFalses.map((el) => fieldsDictionary[el[0]]);
      const invalidFields = errors.join(', ');
      const isPlural = errors.length > 1;
      dispatch(
        AddAlert(
          'warning',
          `Campo${isPlural ? 's' : ''} inválido${
            isPlural ? 's' : ''
          }: ${invalidFields}`
        )
      );
      flag = true;
    }
    if (!flag) {
      const map = document.getElementById('mapsToRender');
      map.addEventListener('click', (e) => {
        if (e?.srcElement?.id === 'info-window-button') {
          dispatch(modalOpen('open building'));
        }
      });
      dispatch([payloadBuilder(formData, null, type)]);
    }
  };
};

export const generateInfoWindow = (data, number, street, marker) => {
  const payload = {
    adType: data?.adType,
    bedrooms: data?.bedrooms,
    garages: data?.garages,
    inputIntervals: data?.inputIntervals,
    realtyType: data?.realtyType,
    suites: data?.suites,
    processed_address_number: number,
    processed_address_street: street,
  };

  const id = Math.ceil(Math.random() * 100001);
  return (dispatch) => {
    dispatch([loading(), setIsLoadingMap(true)]);
    Promise.resolve(getInfoWindowData(payload))
      .then((res) => {
        dispatch(closeInfowindowsSecondary());
        const { data } = res?.data;
        const infowindow = infoWindowOffersSecundary({
          payload: data,
          id,
          marker,
          actions: [
            {
              id: 'SeeAdverts',
              action: () => {
                dispatch(generateBuildingDetailsModal(payload));
              },
            },
          ],
        });
        infowindow.open();
        dispatch(setInfowindowsSecondary(infowindow.getInfowindow()));
      })
      .catch((err) => {
        console.error(err);
        dispatch(
          AddAlert('error', 'Não foi possível encontrar os dados no momento.')
        );
      })
      .finally(() => dispatch([loaded(), setIsLoadingMap(false)]));
  };
};

export const generateBuildingDetailsModal = (payload) => {
  return (dispatch) => {
    dispatch([loading(), setIsLoadingMap(true)]);
    Promise.resolve(getModalInfoOffersSecondary(payload))
      .then((res) => {
        dispatch(updateBuildingData(res?.data?.data));
        dispatch(modalOpen('open building secondary'));
      })
      .finally(() => dispatch([loaded(), setIsLoadingMap(false)]));
  };
};

export const generateMultipleAdvertsFoundInfoWindow = (
  payloadArray,
  marker,
  payloadIndex = 0
) => {
  return (dispatch) => {
    dispatch([loading(), setIsLoadingMap(true)]);
    const { id, location, ...payload } = payloadArray[payloadIndex];
    Promise.resolve(getInfoWindowData(payload))
      .then((res) => {
        dispatch(closeInfowindowsSecondary());
        const { data } = res?.data;
        const infowindow = multipleOffersInfowindow({
          payload: data,
          id,
          marker: marker,
          map: Map.map,
          index: payloadIndex,
          actions: [
            {
              id: 'SeeAdverts',
              action: () => {
                dispatch(generateBuildingDetailsModal(payload));
              },
            },
            {
              id: 'PreviousButton',
              action: () => {
                if (payloadIndex > 0) {
                  dispatch(
                    generateMultipleAdvertsFoundInfoWindow(
                      payloadArray,
                      marker,
                      payloadIndex - 1
                    )
                  );
                  infowindow.previousContent();
                }
              },
            },
            {
              id: 'NextButton',
              action: () => {
                if (payloadIndex < payloadArray.length - 1) {
                  dispatch(
                    generateMultipleAdvertsFoundInfoWindow(
                      payloadArray,
                      marker,
                      payloadIndex + 1
                    )
                  );
                  infowindow.nextContent();
                }
              },
            },
          ],
        });
        infowindow.open();
        dispatch(setInfowindowsSecondary(infowindow.getInfowindow()));
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => dispatch([loaded(), setIsLoadingMap(false)]));
  };
};
